import { UserPermissions } from '~/domain/dashboard/user/permissions/models/UserPermision'

export type RoutePermissionRule =
  | UserPermissions
  | { any: UserPermissions[] }
  | { all: UserPermissions[] }

/** Chave = path normalizado (sem query/hash, sem trailing slash). */
export const ROUTE_PERMISSION_MAP: Record<string, RoutePermissionRule> = {
  '/dashboard/catalog/products': UserPermissions.READ_PRODUCT,
  '/dashboard/catalog/products/new': {
    all: [UserPermissions.READ_PRODUCT, UserPermissions.CREATE_PRODUCT]
  }
}

export const ROUTE_PERMISSION_PREFIX_RULES: Array<{ prefix: string, rule: RoutePermissionRule }> = [
  {
    prefix: '/dashboard/catalog/products/edit',
    rule: {
      all: [UserPermissions.READ_PRODUCT, UserPermissions.UPDATE_PRODUCT]
    }
  }
]

export function normalizeRoutePath (path: string): string {
  const withoutQueryAndHash = path.split('?')[0]?.split('#')[0] ?? path

  if (withoutQueryAndHash === '/') {
    return withoutQueryAndHash
  }

  return withoutQueryAndHash.endsWith('/')
    ? withoutQueryAndHash.slice(0, -1)
    : withoutQueryAndHash
}

export function resolveRoutePermissionRule (path: string): RoutePermissionRule | undefined {
  const normalizedPath = normalizeRoutePath(path)

  const exactRule = ROUTE_PERMISSION_MAP[normalizedPath]
  if (exactRule != null) {
    return exactRule
  }

  let bestMatch: { prefix: string, rule: RoutePermissionRule, normalizedPrefixLength: number } | undefined

  for (const entry of ROUTE_PERMISSION_PREFIX_RULES) {
    const normalizedPrefix = normalizeRoutePath(entry.prefix)
    if (!normalizedPath.startsWith(normalizedPrefix)) {
      continue
    }

    if (bestMatch == null || normalizedPrefix.length > bestMatch.normalizedPrefixLength) {
      bestMatch = { ...entry, normalizedPrefixLength: normalizedPrefix.length }
    }
  }

  return bestMatch?.rule
}
